import { useParams, Navigate } from 'react-router-dom'
import React, { useState, useEffect } from 'react'

import '../App.css'
import BridgelinxLogo from '../logo.png'

import { useAuth } from '../hooks/auth'
import { Form, Button, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import { RenderSchema } from '../utils/FormRenderer'
import { UnAuthorizedResult, AlertBanner } from '../components/auth/Auth'
import { LoginFormSchema, ForgotPasswordSchema, SignUpSchema } from '../utils/FormSchemas'

const Login = () => {
	const [form] = Form.useForm()
	const { action } = useParams()
	const [signup, setSignup] = useState(false)
	const [loading, setLoading] = useState(false)
	const [authorized, setAuthorized] = useState(true)
	const [forgotPassword, setForgotPassword] = useState(false)
	const [alert, setAlert] = useState({ type: '', message: '' })
	const { authorization } = useAuth(setLoading, setAuthorized, setAlert)

	useEffect(() => {
		if (action === 'login') {
			setForgotPassword(false)
			setSignup(false)
		} else if (action === 'forgotPassword') {
			setForgotPassword(true)
			setSignup(false)
		} else if (action === 'signup') {
			setForgotPassword(false)
			setSignup(true)
		}
	}, [action])

	useEffect(() => {
		if (alert.type.length > 0) {
			setAlert({ type: '', message: '' })
		}
	}, [authorized, forgotPassword, signup]) // eslint-disable-line

	// GCP_DOWNTIME_MITIGATION: redirect signup to login
	if (action === 'signup') {
		return <Navigate to='/auth/login' replace />
	}

	return (
		<div className='FullWidthHeight DisplayFlex'>
			<div className='HalfWidth FullHeight LoginLeft'></div>
			<div className='HalfWidth FullHeight FlexColumnBox LoginRight'>
				{authorized ? (
					<Form
						key='LoginForm'
						layout='vertical'
						className='HalfWidth'
						form={form}
						onFinish={(values) =>
							authorization({
								signup,
								forgotPassword,
								email: values.email + '@bridgelinxpk.com',
								password: values.password,
								firstName: values?.firstName,
								lastName: values?.lastName,
							})
						}
					>
						<div className='w-full flex flex-col items-center'>
							<img className='w-1/2 h-auto mb-12 mx-auto ' src={BridgelinxLogo} alt='' />
							{alert.type !== '' && <AlertBanner alert={alert} setAlert={setAlert} />}
						</div>
						{signup ? RenderSchema(SignUpSchema()) : forgotPassword ? RenderSchema(ForgotPasswordSchema()) : RenderSchema(LoginFormSchema())}
						<div className='FullWidth CenterAlign HalfPaddingTop'>
							<Form.Item>
								<div className='FlexRow'>
									<Button className='Button LoginButton' htmlType='submit' disabled={loading}>
										{loading && <Spin className='HalfMarginRight' indicator={<LoadingOutlined style={{ color: '#808080' }} spin />} />}
										{loading ? 'Please Wait' : signup ? 'Register' : forgotPassword ? 'Confirm' : 'Login'}
									</Button>
								</div>
							</Form.Item>
							{!signup && (
								<>
									{!forgotPassword ? (
										<div>
											<Form.Item>
												<a className='TertiaryButton' href='/auth/forgotPassword' onClick={() => !loading && setForgotPassword(true)} disabled={loading}>
													Forgot Password?
												</a>
											</Form.Item>
											{/* GCP_DOWNTIME_MITIGATION: signup link disabled
											<Form.Item>
												<a className='TertiaryButton' href='/auth/signup' onClick={() => !loading && setSignup(true)} disabled={loading}>
													Don't have an account? Sign Up.
												</a>
											</Form.Item>
											*/}
										</div>
									) : (
										<Form.Item>
											<a className='TertiaryButton' href='/auth/login' onClick={() => !loading && setForgotPassword(false)} disabled={loading}>
												Try Logging in Again?
											</a>
										</Form.Item>
									)}
								</>
							)}
							{signup && (
								<Form.Item>
									<a className='TertiaryButton' href='/auth/login' onClick={() => !loading && setSignup(false)} disabled={loading}>
										Have an account? Login.
									</a>
								</Form.Item>
							)}
						</div>
					</Form>
				) : (
					<UnAuthorizedResult
						onClickFunction={() => {
							form.resetFields()
							setAuthorized(true)
						}}
					/>
				)}
			</div>
		</div>
	)
}

export default Login
